import api from '~/services/api';

export default async function existeTributacaoDoNCMUF(
  UF: string,
  codNCM: number,
): Promise<boolean> {
  const {
    data: { data },
  } = await api.post('/verificaTribNcmUf', {
    uf: UF,
    cod_ncm: codNCM,
  });
  if (!data || data.length <= 0) {
    return false;
  }
  return true;
}
